import { render, staticRenderFns } from "./GridWorkGallery.vue?vue&type=template&id=120b9e8a&scoped=true"
import script from "./GridWorkGallery.vue?vue&type=script&lang=js"
export * from "./GridWorkGallery.vue?vue&type=script&lang=js"
import style0 from "./GridWorkGallery.vue?vue&type=style&index=0&id=120b9e8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b9e8a",
  null
  
)

export default component.exports